import { render, staticRenderFns } from "./DeliveryOrderTab.vue?vue&type=template&id=58c1543a&scoped=true"
import script from "./DeliveryOrderTab.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderTab.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrderTab.vue?vue&type=style&index=0&id=58c1543a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c1543a",
  null
  
)

export default component.exports